/** Find the index of the snap height closest to `currentHeight`. */
export const findClosestSnapIndex = (currentHeight: number, snapHeights: number[]): number => {
    let closestIndex = 0;
    let closestDist = Math.abs(currentHeight - (snapHeights[0] ?? 0));
    for (let i = 1; i < snapHeights.length; i++) {
        const dist = Math.abs(currentHeight - (snapHeights[i] ?? 0));
        if (dist < closestDist) {
            closestDist = dist;
            closestIndex = i;
        }
    }
    return closestIndex;
};
